<template>
  <div>
    <!-- PC端：右侧悬浮 -->
    <div class="fixed right-4 top-1/2 z-50 hidden md:flex flex-col gap-3">
      <!-- WhatsApp -->
      <a :href="`https://wa.me/${set.whatsApp}`" target="_blank" rel="noopener"
        class="group relative w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#25D366] hover:bg-[#25D366] hover:text-white transition-all"
        aria-label="Contact via WhatsApp">
        <i class="fa fa-whatsapp text-lg"></i>
        <span
          class="absolute right-14 top-1/2 -translate-y-1/2 bg-black px-4 py-2 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap text-sm text-white">
          WhatsApp:{{ set.whatsApp }}
        </span>
      </a>
      <!-- 电话 -->
      <a :href="`tel:${set.linkPhone}`"
        class="group relative w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#007AFF] hover:bg-[#007AFF] hover:text-white transition-all"
        aria-label="Call us">
        <i class="fa fa-phone text-lg"></i>
        <span
          class="absolute right-14 top-1/2 -translate-y-1/2 bg-black px-4 py-2 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap text-sm text-white">
          {{ set.linkPhone }}
        </span>
      </a>
      <!-- 邮箱 -->
      <a :href="`mailto:${set.email}?subject=Inquiry%20from%20Website`"
        class="group relative w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#EA4335] hover:bg-[#EA4335] hover:text-white transition-all"
        aria-label="Send email">
        <i class="fa fa-envelope text-lg"></i>
        <span
          class="absolute right-14 top-1/2 -translate-y-1/2 bg-black px-4 py-2 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap text-sm text-white">
          {{ set.email }}
        </span>
      </a>

      <!-- 联系我们 -->
      <div class="group relative">
        <button
          class="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#07C160] hover:bg-[#07C160] hover:text-white transition-all"
          aria-label="WeChat QR Code">
          <i class="fa fa-weixin text-lg"></i>
        </button>
        <!-- 二维码弹窗（hover显示） -->
        <div
          class="absolute right-16 top-1/2 -translate-y-1/2 bg-black p-2 rounded-md shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 min-w-[12rem] h-[12rem] flex items-center justify-center">
          <!-- 图片样式调整：确保填充容器且不拉伸 -->
          <img :src="set.wechatOssUrl" alt="WeChat QR Code"
            class="w-full h-full object-contain" />
        </div>
      </div>

      <!-- 返回顶部 -->
      <button @click="scrollToTop"
        class="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-800 hover:bg-[#000000] hover:text-white transition-all"
        aria-label="Back to top">
        <i class="fa fa-arrow-up text-lg"></i>
      </button>
    </div>

    <!-- 移动端：底部固定 -->
    <div
      class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex gap-3 md:hidden px-2 py-2 bg-white rounded-full shadow-xl">
      <a href="https://wa.me/1234567890" target="_blank" rel="noopener"
        class="w-12 h-12 flex items-center justify-center text-[#25D366]" aria-label="WhatsApp">
        <i class="fa fa-whatsapp text-xl"></i>
      </a>
      <a href="tel:+1-800-123-4567" class="w-12 h-12 flex items-center justify-center text-[#007AFF]" aria-label="Call">
        <i class="fa fa-phone text-xl"></i>
      </a>
      <a href="mailto:sales@onlyimaging.com?subject=Inquiry"
        class="w-12 h-12 flex items-center justify-center text-[#EA4335]" aria-label="Email">
        <i class="fa fa-envelope text-xl"></i>
      </a>
      <router-link to="/contact" class="w-12 h-12 flex items-center justify-center text-primary" aria-label="Contact">
        <i class="fa fa-comments text-xl"></i>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { indexSet } from '@/api/index'
onMounted(() => {
  getIndexSet()
  // 3秒自动切换一次
  // slideInterval = setInterval(nextSlide, 3000)
})
const set = ref({})

const getIndexSet = async () => {
  let res = await indexSet()
  set.value = res.data
}

// 返回顶部功能
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<style scoped>
/* 修复移动端底部内容被遮挡问题（配合页面使用） */
body {
  padding-bottom: 80px;
  /* 适配移动端底部悬浮高度 */
}

@media (min-width: 768px) {
  body {
    padding-bottom: 0;
    /* PC端无需底部内边距 */
  }
}
</style>